export default "__VITE_ASSET__W1XDfT4$__"